// extracted by mini-css-extract-plugin
export default {"others-header":"Header_others-header__5wj2Y","others-header__buttons":"Header_others-header__buttons__Moz1y"};